<div class="dropup zas-info-directive zbd-info">
    <div class="dropdown-toggle">
        <span
            class="zas-header-icon icon-info info-action"
            (click)="dropdown.style.display = 'block'"
        ></span>
    </div>
    <div class="dropdown-menu dropdown-menu-ie-fix" #dropdown>
        <div class="close">
            <span
                class="zas-icon icon-close-tag"
                (click)="dropdown.style.display = 'none'"
            ></span>
        </div>
        <div class="headline">Hinweis</div>
        <div class="body">
            <ng-content></ng-content>
            <div class="zas-row"></div>
        </div>
    </div>
</div>
